import { DroneEntity, DroneStatusType } from '@src/core/features';

export interface MapLocationEntity {
  address?: string;
  latitude: number;
  longitude: number;
}

export interface IDronesInitialState {
  selectedDrone: DroneEntity | null;
  hoveredDrone: DroneEntity | null;
  collapse: {
    [DroneStatusType.IDLE]: boolean;
    [DroneStatusType.MISSION]: boolean;
  };
  location?: MapLocationEntity;
  showTakeoffConfirm: boolean;
  missionId?: string;
  manualControl: Record<string, boolean>; 
}

const initialState: IDronesInitialState = {
  selectedDrone: null,
  hoveredDrone: null,
  collapse: {
    [DroneStatusType.IDLE]: true,
    [DroneStatusType.MISSION]: true,
  },
  location: undefined,
  showTakeoffConfirm: false,
  missionId: undefined,
  manualControl: {}, 
};

export default initialState;
